import { CurrencyInr, Lock, ShieldCheck, Users } from "@phosphor-icons/react";
import logger from "../utils/logger";
import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API, getAuthHeaders } from "../context/AuthContext";
import { useWebSocket } from "../context/WebSocketContext";

function formatINR(num) {
  if (num === null || num === undefined) return "0";
  return Number(num).toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

const cardConfig = [
  {
    key: "total_company_profit",
    label: "Total Company Profit",
    sublabel: "Joining Fees + 20% Safety Split",
    icon: CurrencyInr,
    color: "#00E5FF",
  },
  {
    key: "global_tiered_lock_amount",
    label: "Global Tiered Lock",
    sublabel: "Locked Team Bonuses",
    icon: Lock,
    color: "#F59E0B",
  },
  {
    key: "downline_safety_pool",
    label: "Downline Safety Pool",
    sublabel: "40% Split Protection Fund",
    icon: ShieldCheck,
    color: "#10B981",
  },
  {
    key: "active_users",
    label: "Active Users",
    sublabel: "Paid ₹2,999 Fee",
    icon: Users,
    color: "#A78BFA",
    isCurrency: false,
  },
];

export default function StatsCards() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const ws = useWebSocket();

  const fetchStats = useCallback(() => {
    axios
      .get(`${API}/admin/stats`, { headers: getAuthHeaders() })
      .then((res) => setStats(res.data))
      .catch((err) => logger.error("Stats error:", err))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { fetchStats(); }, [fetchStats]);

  // WebSocket: refresh on any update
  useEffect(() => {
    if (!ws) return;
    const unsub1 = ws.subscribe("withdrawal_update", fetchStats);
    const unsub2 = ws.subscribe("stats_update", fetchStats);
    return () => { unsub1(); unsub2(); };
  }, [ws, fetchStats]);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="stats-cards">
      {cardConfig.map((card, idx) => {
        const Icon = card.icon;
        const value = stats ? stats[card.key] : 0;
        const isCurrency = card.isCurrency !== false;
        return (
          <div
            key={card.key}
            data-testid={`stat-card-${card.key}`}
            className="group rounded-md border border-white/10 p-5 transition-all duration-200 hover:-translate-y-0.5 hover:border-white/20"
            style={{ background: "#121212", animationDelay: `${idx * 80}ms` }}
          >
            <div className="flex items-start justify-between mb-4">
              <div
                className="w-10 h-10 rounded-md flex items-center justify-center"
                style={{ background: `${card.color}15` }}
              >
                <Icon size={20} weight="duotone" style={{ color: card.color }} />
              </div>
            </div>
            <div>
              {loading ? (
                <div className="h-8 w-32 rounded bg-white/5 animate-pulse" />
              ) : (
                <p
                  className="text-2xl font-bold text-white"
                  style={{ fontFamily: "'JetBrains Mono', monospace" }}
                >
                  {isCurrency ? `₹ ${formatINR(value)}` : formatINR(value)}
                </p>
              )}
              <p className="text-xs text-[#A1A1AA] mt-1.5">{card.label}</p>
              <p className="text-[10px] text-[#A1A1AA]/60 mt-0.5">{card.sublabel}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
